import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { OrganizationService } from '@/infra/services/organization';
import type { SelectOption } from '@/components/ui/SelectOptions/types';

const Service = OrganizationService.getInstance();

export const useGetOrganizations = () => {
	return useQuery<SelectOption[], Error>(
		[QUERY_KEYS.GET_ORGANIZATIONS],
		async () => {
			const response = await Service.index();
			return response.map((organization) => ({
				label: organization.name,
				value: organization.id
			}));
		}
	);
};
